module.exports = __webpack_public_path__ + "img/pdffilea.a9781e1f.svg";